import { render, staticRenderFns } from "./pricingList.vue?vue&type=template&id=602c97c1&scoped=true&"
import script from "./pricingList.vue?vue&type=script&lang=js&"
export * from "./pricingList.vue?vue&type=script&lang=js&"
import style0 from "./pricingList.vue?vue&type=style&index=0&id=602c97c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602c97c1",
  null
  
)

export default component.exports